import React from 'react';
import { BetType } from '../../enums/tableNumbers';
import { COLOR_BY_NUMBER } from '../../enums/colorByNumber';

export const LastResultItem = ({ lastResult, index }) => {
  return (
    <div data={BetType[`StraightUp_${lastResult}`]} className={`number-title-box ${index ? '' : 'active'}`}>
      <span data={BetType[`StraightUp_${lastResult}`]}
            className={`${COLOR_BY_NUMBER[lastResult].color}`}>{lastResult}</span>
    </div>
  );
};
